import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-listformat/polyfill';
import React from 'react';
import { render } from 'react-dom';
import * as Sentry from '@sentry/react';
import { App, appHistory } from './containers/App';
import './MediaManager.scss';
import { runFullStoryLogger } from './services/loggers/fullStoryLogger';
import { getLocale } from './utils/env/getLocale';
import { parentConnection, ParentConnectionEvent } from './services/parentConnection';
import { setupSentry } from './monitoring/sentry';

if (getLocale() === 'vi') {
  import('./MediaManager-vi.scss');
}

setupSentry(appHistory);
runFullStoryLogger();

appHistory.listen((location) => {
  parentConnection.emit(ParentConnectionEvent.RouteChanged, location);
});

const AppWithProfiler = Sentry.withProfiler(App);

render(<AppWithProfiler />, document.getElementById('root'));
